import React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

export default createSvgIcon(React.createElement(
  'g',
  null,
  React.createElement('path', { d: 'M16 23.45a1.37 1.37 0 0 1-1.21-.7L7.65 10.38a1.42 1.42 0 0 1 0-1.38 1.4 1.4 0 0 1 1.22-.7h14.29a1.38 1.38 0 0 1 1.21.7 1.42 1.42 0 0 1 0 1.41l-7.14 12.34a1.4 1.4 0 0 1-1.23.7zm.65-1zM8.87 9.57a.09.09 0 0 0-.09 0 .08.08 0 0 0 0 .1l7.14 12.43a.28.28 0 0 0 .18 0l7.15-12.38a.16.16 0 0 0 0-.1.11.11 0 0 0-.09 0z' })
));